export type DocumentFilter = {
  phase: string;
  kind: string;
  subject: string;
  unsigned: boolean;
  sourceFilter: string;
  dateFrom: string;
  dateTo: string;
};
export function preferenceKey(org: string | undefined, user: string | undefined) {
  return `document-review-filter:${org ?? ''}:${user ?? ''}`;
}
export function restoreDocumentFilter(raw: string | null): DocumentFilter {
  let parsed: Record<string, unknown> = {};
  try {
    const value = JSON.parse(raw ?? '{}');
    if (value && typeof value === 'object' && !Array.isArray(value)) parsed = value;
  } catch {
    /* Invalid browser preferences are ignored. */
  }
  const text = (key: string) => (typeof parsed[key] === 'string' ? (parsed[key] as string) : '');
  return {
    phase: text('phase'),
    kind: text('kind'),
    subject: text('subject'),
    unsigned: parsed.unsigned === true,
    sourceFilter: text('sourceFilter'),
    dateFrom: text('dateFrom'),
    dateTo: text('dateTo'),
  };
}
